import React from 'react';

import Container from './Container';
import Date from './Date';
import IpAddress from "./IpAddress";
import User from "./User";

export default ({ log }) => (
  <Container>
    <Date>{log.created_at}</Date>
    <IpAddress>{log.ip_address}</IpAddress>
    <User>{log.user_email}</User>
  </Container>
);
